<template lang='pug'>
  bf-flex.profile-header.component
    span.tab.personal
      router-link( :to='{ name: "profile" }' ) {{ $t('Personal') }}
    span.tab.business( v-if='account.merchant' )
      router-link( :to='{ name: "business-profile" }' ) {{ $t('Business') }}
    span.tab.business( v-if='account.merchant' )
      router-link( :to='{ name: "settings" }' ) {{ $t('Settings') }}
    span.tab.account( v-if='account.merchant' )
      router-link( :to='{ name: "account" }' ) {{ $t('Account') }}
</template>

<script>
  export default {
    name: 'profile-header.component',

    props: {
      title: String,
      account: [ Array, Object ],
    }
  }
</script>

<style scoped lang='stylus'>
  .router-link-active
    background orange 
    border-radius 5px
    padding 5px 15px
    color white
    font-weight bold

  .profile-header
    justify-content center
    background white
    box-shadow var(--shadow-box)
    padding 10px 0px
    border-radius 5px

  .title
    padding 8px 24px
    background var(--bg-nav)
    margin 0 auto

  .view .view-header
    background var(--bg-nav)
    padding 0 12px
    position fixed
    top 136px
    z-index 3

  .heading, .tab
    padding 8px 24px

  .heading
    margin-right auto

  .tab
    background white
    color rgb( 175 175 175 )
    border-left 1px solid rgba( 0 0 0 .1 )
    border-right 1px solid rgba( 255 255 255 1 )
    position relative
    padding 10px 17px
    top 1px
    &:first-child
      border 0
</style>
